export const getWeekdays = (state) => state.weekdays
export const getCompanyWorkDays = (state) => (id) => state.companiesWorkDays[id] || []
export const getWeekdayEnums = (state) => state.weekday_enums
